<template>
  <li @click="chooseSelect" class="s-item over">{{ label }}</li>
</template>
<script>
import Emitter from "@/utils/emitter";

export default {
  name: "ByOption",
  componentName: "ByOption",

  mixins: [Emitter],

  props: {
    label: { type: String },
    value: { type: String },
    item: { type: Object }
  },
  created() {},
  methods: {
    chooseSelect() {
      let curVal = {
        label: this.label,
        value: this.value,
        item: this.item
      };
      console.log("🚀 ~ curVal", curVal);
      this.dispatch("BySelect", "curOptVal", curVal);
    }
  }
};
</script>
<style scoped>
.s-item {
  cursor: pointer;
  color: #555;
  line-height: 30px;
  font-size: 13px;
  padding: 0 5px;
  font-size: 12px;
}
.s-item:hover {
  background: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/select/byOption.vue